import { FC } from 'react';

// import { CtaImageBox } from '@bumble/ui-kit';
// import lexemes from 'components/lexemes/page-about';

export const AboutCeoContainer: FC = () => {
  return null;
  // (
  //    <CtaImageBox
  //      image={{
  //        src: '/project-love/assets/whitney.jpg',
  //        alt: 'Portrait of Whitney Wolfe Herd, founder and CEO of Bumble.',
  //        style: {
  //          objectFit: 'cover',
  //          objectPosition: 'top',
  //        },
  //      }}
  //      imagePosition="start"
  //      title={lexemes.lxPageAboutCeoTitle}
  //      description={lexemes.lxPageAboutCeoDescription}
  //      isHtml={true}
  //    />
  //  );
};
